import { Resource as r, API as e } from "@coveo/platform-client";
const t = class t extends r {
  /**
   * Returns a list of in-app widgets for the specified project.
   *
   * @param {string | undefined} projectId ID of the project for which to retrieve in-app widgets.
   * @returns {Promise<InProductExperienceModel[]>} List of in-app widgets for the specified project.
   */
  listInAppWidgetsByProjectId(i) {
    return this.api.get(this.buildPath(`${t.baseUrl}/projectid`, { projectid: i }));
  }
};
t.baseUrl = `/rest/organizations/${e.orgPlaceholder}/pages/inappwidgets`;
let s = t;
export {
  s as InAppWidgetResource
};
//# sourceMappingURL=InAppWidgetResource.js.map
